import api from '@/services/api';
import { make } from 'vuex-pathify';
import { saveFileFromBackend } from '@/assets/js/utility.js';

const state = {
  sessions: {},
};

const mutations = {
  ...make.mutations(state),
  ADD_SESSION(state, session) {
    state.sessions[session.session_id] = session;
  },
  DELETE_SESSION(state, sessionId) {
    delete state.sessions[sessionId];
  },
};

const actions = {
  async addSession({ commit }, { files } = {}) {
    let formData = new FormData();
    for (let file of files) formData.append('files', file, file.name);
    const r = await api.post('v2/files-session', formData, {
      noWrap: true,
      headers: { 'Content-Type': 'multipart/form-data;' },
    });
    commit('ADD_SESSION', r.data.data);
    return r.data.data.session_id;
  },
  async downloadSession(_, { sessionId, headers, asText = false, fileName, ...payload } = {}) {
    const r = await api.post(`v2/files-session/${sessionId}/download`, payload, {
      timeout: 0,
      responseType: 'arraybuffer',
      headers,
    });
    if (asText) {
      const textDecoder = new TextDecoder('utf-8');
      const fileText = textDecoder.decode(new Uint8Array(r.data));
      return JSON.parse(fileText);
    } else saveFileFromBackend(r.data, r.headers, fileName);
  },
  async deleteSession({ commit }, { sessionId } = {}) {
    try {
      await api.delete(`v2/files-session/${sessionId}`, { skipDefaultErrorHandler: true });
    } finally {
      commit('DELETE_SESSION', sessionId);
    }
  },
  async sessionAppendToLayer(_, { sessionId, payload } = {}) {
    await api.post(`v2/files-session/${sessionId}/datasource-append`, payload);
  },
  async sessionCreateLayer({ dispatch }, { sessionId, payload } = {}) {
    await api.post(`v2/files-session/${sessionId}/datasource-create`, payload);
    Promise.all([
      dispatch(
        'layers/getLayersMetadata',
        { with_attributes_schema: true, withAdditionalMetadata: true },
        { root: true }
      ),
      dispatch('layers/getLayers', {}, { root: true }),
      dispatch('layers/getLayersSchema', {}, { root: true }),
    ]);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
